"use strict";
exports.__esModule = true;
exports.INJECTION_TYPES = void 0;
exports.INJECTION_TYPES = [
    'JAVASCRIPT',
    'CSS',
    'GLOBAL_CSS',
    'GOOGLE_ANALYTICS',
    'GOOGLE_TAG_MANAGER',
    'CRITEO',
];
//# sourceMappingURL=injection-types.constant.js.map